import axios from './axiosClient'
 
const depotAPI = {
    getDepotList: (type) =>{
        const url ='/Depots'
       return axios.get(url,type)
    },
}

export default depotAPI;